import type { IOrgRepository } from '../repositories/IOrgRepository.js';
import type { OrgEntity } from '../entities/OrgEntity.js';

export interface GetOrgByIdInput {
  id: string;
}

interface Dependencies {
  orgRepository: IOrgRepository;
}

export function createGetOrgByIdUseCase({ orgRepository }: Dependencies) {
  return async function getOrgById(input: GetOrgByIdInput): Promise<OrgEntity | null> {
    return orgRepository.getById(input.id);
  };
}
